import { Portal, Tooltip as ChakraTooltip } from '@chakra-ui/react'
import { mdiInformation, mdiInformationOutline } from '@mdi/js'
import Icon from '@mdi/react'
import * as React from 'react'

export interface ITooltipProps extends ChakraTooltip.RootProps {
    showArrow?: boolean
    portalled?: boolean
    portalRef?: React.RefObject<HTMLElement>
    content: React.ReactNode
    contentProps?: ChakraTooltip.ContentProps
    disabled?: boolean
    css?: React.CSSProperties
}

export const Tooltip = React.forwardRef<HTMLDivElement, ITooltipProps>(function Tooltip(props, ref) {
    const {
        showArrow,
        children,
        disabled,
        portalled,
        content,
        contentProps,
        portalRef,
        css,
        openDelay = 0,
        closeDelay = 0,
        ...rest
    } = props

    const [isHovered, setIsHovered] = React.useState(false)

    const defaultChildren = (
        <span
            style={{ display: 'inline-flex', zIndex: 1, ...css }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <Icon
                path={isHovered ? mdiInformation : mdiInformationOutline}
                size="16px"
                color="var(--chakra-colors-gray-500)"
                style={{ transition: 'opacity 0.2s' }}
            />
        </span>
    )

    if (disabled) return children ?? defaultChildren

    return (
        <ChakraTooltip.Root {...rest} openDelay={openDelay} closeDelay={closeDelay}>
            <ChakraTooltip.Trigger asChild>{children ?? defaultChildren}</ChakraTooltip.Trigger>
            <Portal disabled={!portalled} container={portalRef}>
                <ChakraTooltip.Positioner>
                    <ChakraTooltip.Content ref={ref} {...contentProps}>
                        {showArrow && (
                            <ChakraTooltip.Arrow>
                                <ChakraTooltip.ArrowTip />
                            </ChakraTooltip.Arrow>
                        )}
                        {content}
                    </ChakraTooltip.Content>
                </ChakraTooltip.Positioner>
            </Portal>
        </ChakraTooltip.Root>
    )
})
